// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + "case-studies" + "." + "722bd466" + ".chunk.css";
};